import Vue from 'vue';
import VueConfirmDialog from 'vue-confirm-dialog';

Vue.use(VueConfirmDialog);
Vue.component('vue-confirm-dialog', VueConfirmDialog.default);
